import Page from '@/components/Page';
import Stack from '@/components/Stack';

import ClientSessionsTable from './ClientSessionsTable';
import HashStatsTable from './HashStatsTable';

const ClientSessionsPage = () => {
  return (
    <Page size="full" title="Client Sessions (fleet)">
      <Stack vertical gap={16}>
        <HashStatsTable />
        <ClientSessionsTable />
      </Stack>
    </Page>
  );
};

export default ClientSessionsPage;
